import { useRef } from "react";
import { motion } from "framer-motion";
import { ChevronLeft, ChevronRight, Clock } from "lucide-react";
import { LATEST } from "@/data/news";

export default function LatestSlider({ items }) {
  const data = items && items.length ? items : LATEST;
  const scroller = useRef(null);
  const by = (d) => scroller.current?.scrollBy({ left: d * 360, behavior: "smooth" });

  return (
    <section
      id="latest"
      data-testid="latest-slider"
      className="bg-[#F4F4F0] border-b border-[#0F0F0F]"
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-8 md:py-10">
        <div className="flex items-center justify-between mb-5">
          <div className="flex items-center gap-3">
            <span className="w-2 h-2 rounded-full bg-[#D92525] animate-pulse" />
            <h2 className="font-sans-dev text-[12px] md:text-[13px] tracking-[0.28em] uppercase font-bold">
              ताज़ा ख़बरें · Latest
            </h2>
          </div>
          <div className="flex items-center gap-2">
            <button data-testid="latest-prev" onClick={() => by(-1)} aria-label="पिछला"
              className="w-9 h-9 rounded-full border border-[#0F0F0F]/25 hover:bg-[#0F0F0F] hover:text-white flex items-center justify-center transition-colors">
              <ChevronLeft size={16} />
            </button>
            <button data-testid="latest-next" onClick={() => by(1)} aria-label="अगला"
              className="w-9 h-9 rounded-full border border-[#0F0F0F]/25 hover:bg-[#0F0F0F] hover:text-white flex items-center justify-center transition-colors">
              <ChevronRight size={16} />
            </button>
          </div>
        </div>

        <div ref={scroller} className="flex gap-5 overflow-x-auto hide-scrollbar snap-x pb-1">
          {data.map((n, i) => (
            <motion.a
              key={n.id}
              href={n.slug ? `/news/${n.slug}` : "#"}
              data-testid={`latest-item-${n.id}`}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              className="group shrink-0 w-[280px] md:w-[320px] snap-start border border-[#0F0F0F]/15 bg-white"
            >
              <div className="thumb-wrap aspect-[16/9]">
                <img src={n.img} alt={n.title} className="w-full h-full object-contain" />
              </div>
              <div className="p-4">
                <div className="eyebrow text-[#D92525] mb-2 flex items-center gap-2">
                  {n.kicker} <span className="opacity-40">·</span>
                  <span className="inline-flex items-center gap-1 text-[#4A4A4A] normal-case tracking-normal font-sans-dev text-[11px]">
                    <Clock size={11} /> {n.time}
                  </span>
                </div>
                <h3 className="font-serif-dev font-bold text-[16px] leading-snug headline-link">
                  {n.title}
                </h3>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
